import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="rwm-footer">
      <div className="container">
        <div className="row pb-4">
          <div className="col-12 col-md-4">
            <img
              className="rwm-footer__logo d-inline-block align-top"
              src="/remote-work-market.png"
              alt="Remote Work Market"
            />
            <p className="rwm-footer__tagline">
              The remote job board that respects your time.
            </p>
          </div>
          <div className="col-12 col-md-8">
            <div className="row">
              <div className="col-6">
                <p className="rwm-footer__col-heading">For Job Seekers</p>
                <Link className="rwm-footer__link" to="/jobs" data-testid="rwm-footer-browse-jobs">
                  Browse Jobs
                </Link>
                <Link className="rwm-footer__link" to="/register" data-testid="rwm-footer-signup">
                  Sign Up
                </Link>
                <Link className="rwm-footer__link" to="/login" data-testid="rwm-footer-login">
                  Log In
                </Link>
                <Link className="rwm-footer__link" to="/contact" data-testid="rwm-footer-contact">
                  Contact
                </Link>
              </div>
              <div className="col-6">
                <p className="rwm-footer__col-heading">For Companies</p>
                <Link
                  className="rwm-footer__link"
                  to="/for-companies"
                  data-testid="rwm-footer-post-job"
                >
                  Post a Job
                </Link>
                <Link
                  className="rwm-footer__link"
                  to="/for-companies"
                  data-testid="rwm-footer-how-it-works"
                >
                  How It Works
                </Link>
                <Link
                  className="rwm-footer__link"
                  to="/for-companies"
                  data-testid="rwm-footer-pricing"
                >
                  Pricing
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr className="rwm-footer__divider" />

      <div className="container">
        <div className="row rwm-footer__bottom">
          <div className="col-12 col-md-6">
            <p className="rwm-footer__copyright">
              Copyright © 2026 RemoteWorkMarket.com — ONG IT Solutions
            </p>
          </div>
          <div className="col-12 col-md-6 text-md-end">
            <div className="rwm-footer__legal">
              <Link
                className="rwm-footer__legal-link"
                to="/privacy-policy"
                data-testid="rwm-footer-privacy"
              >
                Privacy Policy
              </Link>
              {' · '}
              <Link className="rwm-footer__legal-link" to="/terms" data-testid="rwm-footer-terms">
                Terms of Service
              </Link>
              {' · '}
              <Link className="rwm-footer__legal-link" to="/cookies" data-testid="rwm-footer-cookies">
                Cookie Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
